import React, { useEffect } from 'react'
import { RootState, useAppDispatch } from '../../../../redux/store/store'
import { setErrorMessageSupportChanged } from '../../../../redux/slices/components/ManageReports/manageReportsDataSlice'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const ErrorMessageReport = () => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const errorMessageSupportChanged = useSelector((state: RootState) => state.manageUserReports.errorMessageSupportChanged)

    useEffect(() => {
      
        return () => {
            dispatch( setErrorMessageSupportChanged(false) )
        }

    }, [])
    
    if(!errorMessageSupportChanged)
        return <></>

    return (
        <div className="width-100 height-100 p-absolute center flex-d-column" style={{ backgroundColor: "white", zIndex: 1 }}>
            <p className="fs-24 color-text fw-500 text-align-center" style={{ width: "80%" }}>
                {"The report change of support while you was working on it, you don't have access anymore, please go back"}
            </p>
            <button className="pl-20 pr-20 dark-gray-bg border-radius-3 mt-40 pointer" onClick={() => navigate(-1)} style={{ height: "3.8rem", width: "20rem" }} >
                <p className="fs-18 fw-600 c-white">Go Back</p>
            </button>
        </div>
    )
}

export default React.memo( ErrorMessageReport )